import { render } from "./SimpleCard.vue?vue&type=template&id=39a362ad&scoped=true"
import script from "./SimpleCard.vue?vue&type=script&lang=js"
export * from "./SimpleCard.vue?vue&type=script&lang=js"

import "./SimpleCard.vue?vue&type=style&index=0&id=39a362ad&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a362ad"]])

export default __exports__